import { render } from "./EditProductsPage.vue?vue&type=template&id=fabf67f0&scoped=true&ts=true"
import script from "./EditProductsPage.vue?vue&type=script&lang=ts"
export * from "./EditProductsPage.vue?vue&type=script&lang=ts"

import "./EditProductsPage.vue?vue&type=style&index=0&id=fabf67f0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fabf67f0"]])

export default __exports__